export default "__VITE_ASSET__e6765a16__"